var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"alignImage diagram",attrs:{"alt":("provider " + _vm.illustrationPath + " classification diagram"),"src":(_vm.staticIllustrationsUrl + "/" + _vm.illustrationPath)}})}
var staticRenderFns = []

export { render, staticRenderFns }